import React from 'react';
import ActionButton from './action-button';
import {displayYesNoModal} from '../modal/yes-no-modal';

const DeleteButton = ({skipConfirmation, action, disabled, errorHandler}) => {

  const triggerAction = () => {
    if (skipConfirmation) {
      return action();
    } else {
      return displayYesNoModal(<div className="text-center">Are you sure?</div>, errorHandler)
        .then(isYes => {
          if (isYes) {
            return action();
          } else {
            return Promise.resolve();
          }
        });
    }
  };

  return <ActionButton className="btn-sm btn-danger"
                       action={() => triggerAction()}
                       errorHandler={errorHandler}
                       disabled={disabled}>
    <span className="material-icons align-middle" style={{fontSize: '20px'}}>&#xE872;</span>
  </ActionButton>;
};
export default DeleteButton;
